import { render, staticRenderFns } from "./media_resource_list.vue?vue&type=template&id=fbb5cd64"
import script from "./media_resource_list.vue?vue&type=script&lang=js"
export * from "./media_resource_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports